'use client'

import { useEffect, useState } from 'react'

import { MapContainer } from '../../../features/map'
import { PickupAddressDto } from '../../../shared/api/generated'

export function ItemLocationClient({ pickupAddress }: { pickupAddress: PickupAddressDto }) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => setIsMounted(true), [])

  if (!isMounted) return null

  return (
    <MapContainer
      coordinates={[pickupAddress.latitude, pickupAddress.longitude]}
      height={200}
      width={300}
      isPlacemark
    />
  )
}
